import { defineMessages } from 'react-intl';

export const additionalDetailsSectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Additional Details',
    id: 'qVlmZx',
    description: 'Title of the additional details card in the freight details view',
  },
  insuranceTitle: {
    defaultMessage: 'Insurance',
    id: 'uq2l/s',
    description: 'Heading for the insurance measurement row',
  },
  conditionOfGoods: {
    defaultMessage: 'Condition of Goods',
    id: 'zQeJeN',
    description: 'Label for the insured commodity condition',
  },
  category: {
    defaultMessage: 'Category',
    id: '5xfNVn',
    description: 'Label for the insured commodity category',
  },
  insuredValue: {
    defaultMessage: 'Insured Value',
    id: 'YBNr+S',
    description: 'Label for the insured declared value',
  },
  marksNumbers: {
    defaultMessage: 'Marks & Numbers',
    id: 'rY6qV4',
    description: 'Label for the insurance marks and numbers field',
  },
  handlingChargeTitle: {
    defaultMessage: 'Handling Charge',
    id: 'sgS5py',
    description: 'Heading for the handling charge section',
  },
  referencesTitle: {
    defaultMessage: 'References',
    id: 'lRrcuM',
    description: 'Heading for the shipment references row',
  },
  shipmentNumber: {
    defaultMessage: 'Shipment #{number}',
    id: 'Y+nfEG',
    description: 'Reference label showing the freight shipment id',
  },
});
